<template>
  <div />
</template>

<script>

/**
 * Vue: Venn preorder cta (venn-preorder-cta)
 * -----------------------------------------------------------------------------
 * Preorder Sticky CTA component for Venn apps.
 * - Static section.
 *
 */

/**
 * DOM selectors.
 */
const selectors = {
  mainContent: '#main-content',
  stickySection: '.venn-preorder-cta--sticky',
}

export default {
  name: 'VennPreorderCta',

  data() {
    return {
      mainContent: document.querySelector(selectors.mainContent),
      stickySection: document.querySelector(selectors.stickySection),
    }
  },

  mounted() {
    this.handleStickySection()
    this.handleScrollBottom()
  },

  methods: {

    /**
     * Detect if Preorder CTA section is sticky.
     * Add padding-bottom to main content to offset sticky section
     */
    handleStickySection() {
      if (!this.stickySection || !this.stickySection.dataset.stickyOffset) {
        return
      }

      const sectionHeight = this.stickySection.getBoundingClientRect().height
      this.mainContent.style.paddingBottom = `${sectionHeight}px`
    },

    /**
     * Detect if Preorder CTA section is at the end of page.
     * Change BG to black if at bottom
     */
    handleScrollBottom() {
      if (!this.stickySection) {
        return
      }

      window.addEventListener('scroll', () => {
        const scrolled =
          (document.documentElement.scrollTop + document.documentElement.clientHeight) >=
          document.documentElement.scrollHeight - 81

        if (scrolled) {
          this.stickySection.classList.add('darkBg')
        } else {
          this.stickySection.classList.remove('darkBg')
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import './venn-preorder-cta';
</style>
